import React, { useEffect, useState } from "react"
import Icons from "../../../assets/icons"
import { toast } from "react-toastify";


const REACT_APP_IMAGE_URL = 'https://dbmi-data.s3.ap-south-1.amazonaws.com/'

const Question = ({ question = {}, index = 0, openImageModal, activeIndex = 0, questionNextHandler, questionPreviousHandler, attemptedQuestion = {}, currentSection, eachSectionQuestion }) => {
    const [selectedOption, setSelectedOption] = useState("")
    const [isGuessed, setIsGuessed] = useState(false)
    const [showSaveButton, setshowSaveButton] = useState(false)
    const { questionText, questionImage, questionVideo } = question?.question
    const showToastError = (message) => {
        toast.error(message);
    };
    // option selection
    const optionChangeHandler = (option) => {
        setSelectedOption(option)
    }
    useEffect(() => {
        setshowSaveButton((index + 1) == eachSectionQuestion ? true : false)
    }, [index, eachSectionQuestion])


    // console.log(eachSectionQuestion , "eachSectionQuestion");

    // mark for review
    const markAsReviewHandler = () => {
        const attempData = {
            questionId: question._id,
            isView: true,
            isReview: true,
            isGuessed,
            isSave: false,
            answer: selectedOption || null,
            currentSection: currentSection
        }
        questionNextHandler(attempData)
    }

    //guesHandler
    const guesHandler = (e) => {

        if (!selectedOption) {
            showToastError("Please select option")
            return
        }
        setIsGuessed(!isGuessed)
        // const attempData = {
        //     questionId: question._id,
        //     isView: true,
        //     isReview: false,
        //     isGuessed: true,
        //     isSave: false,
        //     answer: selectedOption || null,
        //     currentSection: currentSection
        // }
        // questionNextHandler(attempData)
    }

    // next handler
    const nextHandler = () => {
        const attempData = {
            questionId: question._id,
            isView: true,
            isReview: false,
            isGuessed,
            isSave: selectedOption ? true : false,
            answer: selectedOption,
            currentSection: currentSection

        }
        questionNextHandler(attempData)
    }
    const handleClick = () => {
        setSelectedOption("");
        setIsGuessed(false)
    };
    //previous handler
    const previousHandler = () => {
        questionPreviousHandler()
    }

    const questionImagePlaceholders = (htmlContent) => {
        const modifiedHtmlContent = htmlContent?.replace(/<img\s+src=Image\[\d+\]>/g, '');
        return modifiedHtmlContent;
    };

    const questionModifiedHtml = questionImagePlaceholders(questionText);

    const imageGenerator = () => {
        if (questionImage?.[0]?.includes('/')) {

            return questionImage?.[0]
        } else {
            return REACT_APP_IMAGE_URL + questionImage?.[0]
        }
    }

    React.useEffect(() => {
        attemptedQuestion?.answer && attemptedQuestion?.currentSection == currentSection && setSelectedOption(attemptedQuestion?.answer)
        setIsGuessed(attemptedQuestion?.isGuessed || false)
    }, [attemptedQuestion])

    return (
        <>
            <div className="question_type question_shadow padding_bar border_bottom">
                <p>Question No. {index + 1}</p>
            </div>
            <div className="question_panel">
                <p dangerouslySetInnerHTML={{ __html: questionModifiedHtml }}></p>
                <figure className="question_img_maximize">
                    {
                        !questionVideo &&
                        questionImage.filter(element => element !== "" && element !== null)?.length > 0 &&
                        <img src={imageGenerator()} alt="" className="img-fluid" />
                    }
                    {
                        !questionVideo &&
                        questionImage.filter(element => element !== "" && element !== null)?.length > 0 &&
                        <figcaption className="img_fullscreen" onClick={() => openImageModal(imageGenerator())}>
                            <img src={Icons.Maximize} alt="" className="img-fluid" />
                        </figcaption>
                    }
                </figure>
                {
                    questionVideo &&
                    <div className="question_video_wrapper">
                        <video
                            src={questionVideo}
                            controls
                            autoPlay
                            muted
                            playsInline
                            className="img-fluid"
                        />
                    </div>
                }
                {/* <div className="answers_panel" onClick={() => query1.refetch()}> */}
                <div className="answers_panel">
                    {
                        question?.options?.length > 0 ? (
                            question?.options?.map((item, i) => {
                                return <div className="custom-control custom-radio" key={item._id} >
                                    <input type="checkbox" className="custom-control-input" id={`answerRadio${i}`} name="answers" onChange={() => optionChangeHandler(item._id)} checked={selectedOption === item._id} />
                                    <label className="custom-control-label" for={`answerRadio${i}`}>
                                        {/* {item?.optionText} */}
                                        <p dangerouslySetInnerHTML={{ __html: item?.optionText }}></p>

                                    </label>
                                </div>
                            })
                        ) : null
                    }



                </div>
                <div className="guess_btn">
                    {/* <input type="checkbox" id="checkbox_1" name="checkboxName" checked={isGuessed} onChange={(e) => setIsGuessed(!isGuessed)} className="btn_guess" hidden="hidden" /> */}
                    <input type="checkbox" id="checkbox_1" name="checkboxName" checked={isGuessed} onChange={(e) => guesHandler(e)} className="btn_guess" hidden="hidden" />

                    <label for="checkbox_1" className={`btn btn_guess ${isGuessed ? 'btn_bg_guess' : ''}`}>
                        {
                            isGuessed &&
                            <span style={{ display: `inline-block` }}>
                                <img src={Icons.GuessIcon} alt="" className="img-fluid" />
                            </span>
                        }
                        I’m Guessing this Question</label>
                </div>
            </div>
            <div className="ques_panel_footer d-flex justify-content-between">
                <div className="review_btns">
                    <input className="btn btn_review" id="checkbox_2" type="checkbox" onChange={markAsReviewHandler} hidden="hidden" />
                    <label for="checkbox_2" className="btn btn_review btn_clear m-0">  Mark for Review & Next</label>
                    <button className="btn btn_review btn_clear" type="button" onClick={handleClick}>Clear Response</button>
                </div>
                <div className="next_prev_btns">
                    {
                        (index === 0) &&
                        <button className="btn btn_prev btn_width" type="button" disabled onClick={previousHandler}>Previous</button>
                    }
                    {
                        (index != 0) &&
                        <button className="btn btn_prev btn_width" type="button" onClick={previousHandler}>Previous</button>
                    }
                    {
                        showSaveButton &&
                        <button className="btn btn_save btn_width" type="button" onClick={nextHandler}>Save</button>
                    }
                    {
                        !showSaveButton &&
                        <button className="btn btn_save btn_width" type="button" onClick={nextHandler}>Save & Next</button>
                    }
                </div>
            </div>
        </>
    )
}

export default Question